import React, { useContext, useState } from "react";


import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { fade, InputBase, Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/core/styles";
import logo from "./logo.png";

import SearchIcon from "@material-ui/icons/Search";
import { AdminContext } from "../../../context/AdminContext";
import AdminApplicationDrawer from "../AdminApplicationDrawer/AdminApplicationDrawer";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        toolbar: {
            justifyContent: "space-between",
        },
        logo: {
            paddingLeft: "1rem",
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            flexGrow: 1,
            display: "none",
            [theme.breakpoints.up("sm")]: {
                display: "block",
            },
        },
        search: {
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            backgroundColor: fade(theme.palette.common.white, 0.15),
            "&:hover": {
                backgroundColor: fade(theme.palette.common.white, 0.25),
            },
            marginLeft: 0,
            width: "100%",
            [theme.breakpoints.up("sm")]: {
                marginLeft: theme.spacing(1),
                width: "auto",
            },
        },
        searchIcon: {
            padding: theme.spacing(0, 2),
            height: "100%",
            position: "absolute",
            pointerEvents: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        inputRoot: {
            color: "inherit",
        },
        inputInput: {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
            transition: theme.transitions.create("width"),
            width: "100%",
            [theme.breakpoints.up("sm")]: {
                width: "40ch",
                "&:focus": {
                    width: "50ch",
                },
            },
        },
    })
);

export default function AdminTopBar() {
    const classes = useStyles();

    const { searchTerm, setSearchTerm } = useContext(AdminContext);

    const [showDrawer, setShowDrawer] = useState(false);

    const toggleDrawer = () => {
        setShowDrawer(!showDrawer);
    };

    const handleSearchChanged = (e: any) => {
        setSearchTerm(e.target.value);
    };

    return (
        <div className={classes.root}>
            <AppBar position="relative">
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        className={classes.menuButton}
                        color="inherit"
                        aria-label="menu"
                        onClick={toggleDrawer}
                    >
                        <MenuIcon />
                    </IconButton>

                    <div className={classes.search}>
                        <div className={classes.searchIcon}>
                            <SearchIcon />
                        </div>
                        <InputBase
                            placeholder="Search…"
                            value={searchTerm}
                            classes={{
                                root: classes.inputRoot,
                                input: classes.inputInput,
                            }}
                            inputProps={{ "aria-label": "search" }}
                            onChange={handleSearchChanged}
                        />
                    </div>
                    <img
                        className={classes.logo}
                        height={"30px"}
                        src={logo}
                        alt="Logo"
                    />
                </Toolbar>

                <AdminApplicationDrawer
                    showDrawer={showDrawer}
                    toogleDrawer={toggleDrawer}
                ></AdminApplicationDrawer>
            </AppBar>
        </div>
    );
}
